mutation VerifySignIn($token: String!, $code: String!) {
  verifySignIn(token: $token, code: $code) {
    token
  }
}
